import * as generalConstants from "../constants/generalConstant";

export const generalReducers = (state = {}, action) => {
  switch (action.type) {
    case generalConstants.OPEN_SIGNUP_MODAL:
      return { ...state, showSignupModal: true };
    case generalConstants.CLOSE_SIGNUP_MODAL:
      return { ...state, showSignupModal: false };
    case generalConstants.OPEN_PAYMENT_ISSUE_MODAL:
      return {
        ...state,
        showPaymentIssueModal: true,
        paymentIssueModelContent: action.payload,
      };
    case generalConstants.CLOSE_PAYMENT_ISSUE_MODAL:
      return {
        ...state,
        showPaymentIssueModal: false,
        paymentIssueModelContent: "",
      };
    default:
      return state;
  }
};

// PAYMENT_ISSUE

export const sendDailyMailTestReducer = (state = {}, action) => {
  switch (action.type) {
    case generalConstants.SEND_TEST_DAILY_MAIL_REQUEST:
      return { ...state, loading: true };
    case generalConstants.SEND_TEST_DAILY_MAIL_SUCCESS:
      return { ...state, loading: false, success: true };
    case generalConstants.SEND_TEST_DAILY_MAIL_FAIL:
      return { ...state, loading: false, success: false };
    default:
      return state;
  }
};
